import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { variables } from '..';

export function ErrorIcon() {
  return (
    <FontAwesomeIcon
      icon={faTimes}
      size="1x"
      fixedWidth
      style={{ color: variables.brandDanger }}
    />
  );
}
